const teacher = {
  en: {
    dashboard: {
      notAssignedTitle: 'Not assigned to a course yet',
      notAssigned: "You're not assigned to this course yet, so its students are hidden. Ask an admin to assign you.",
      title: 'My students',
      subtitle: 'Manage your assigned courses and student progress',
      loadingCourses: 'Loading courses...',
      selectCourse: 'Select course',
      selectCoursePlaceholder: 'Select a course...',
      coursesLabelOne: '{count} student',
      coursesLabelOther: '{count} students',
      searchPlaceholder: 'Search students...',
      searchAria: 'Search students by name or email',
      sortLabel: 'Sort by',
      filterAllStatuses: 'All statuses',
      filterActive: 'Active',
      filterCompleted: 'Completed',
      filterInactive: 'Inactive',
      filterAtRisk: 'At risk',
      statusActive: 'Active',
      statusCompleted: 'Completed',
      statusInactive: 'Inactive',
      statusAtRisk: 'At risk',
      allStatuses: 'All statuses',
      sortAtRisk: 'At risk first',
      sortProgressAsc: 'Progress (low to high)',
      sortLastActive: 'Last active',
      sortAlphabetical: 'Alphabetical',
      loadingStudents: 'Loading students...',
      emptyStudents: 'No students assigned to you for this course yet',
      emptyStudentsDesc: 'Students assigned to you will appear here with their progress.',
      colName: 'Student',
      colStatus: 'Status',
      colProgress: 'Progress',
      colLastActive: 'Last active',
      colQuizAverage: 'Quiz average',
      colAction: 'Action',
      atRiskBadge: 'At risk',
      view: 'View',
      failedToLoadStudents: 'Failed to load students',
      failedToLoadCourses: 'Failed to load courses',
      never: 'Never',
      yesterday: 'Yesterday',
      daysAgoOne: '{count} day ago',
      daysAgoOther: '{count} days ago',
      weeksAgoOne: '{count} week ago',
      weeksAgoOther: '{count} weeks ago',
      monthsAgoOne: '{count} month ago',
      monthsAgoOther: '{count} months ago',
      clearFilters: 'Clear filters',
      noResultsTitle: 'No students found',
      noResultsDesc: 'Try a different name, email or status.',
      filterStatusAria: 'Filter by status',
      sortAria: 'Sort students',
      tableAria: 'Students',
    },
    studentDetail: {
      loading: 'Loading student details...',
      backToDashboard: 'Back to dashboard',
      notFound: 'Student not found',
      notFoundDesc: 'This student is not in this course, or the link is out of date.',
      enrolled: 'Enrolled',
      completedOn: 'Completed: {date}',
      overallProgress: 'Overall progress',
      quizAverage: 'Quiz average',
      basedOnAttempts: 'Based on {count} attempts',
      lessonsCompleted: 'Lessons completed',
      lessonCompletionProgress: 'Lesson completion progress',
      completionPercent: 'Completion %',
      quizPerformance: 'Quiz performance',
      quizFallback: 'Quiz',
      scorePercent: 'Score %',
      lessonsProgress: 'Lessons progress',
      noLessonsData: 'No lessons data available',
      lessonFallbackTitle: 'Lesson {number}',
      completed: 'Completed',
      notStarted: 'Not started',
      quizAttempts: 'Quiz attempts',
      correctOf: '{correct}/{total} correct',
      inProgress: 'In progress',
      passed: 'Passed',
      failed: 'Failed',
      editFeedback: 'Edit feedback',
      provideFeedback: 'Provide feedback',
      refreshData: 'Refresh data',
      messageStudent: 'Message student',
      messagePanelTitle: 'Message {name}',
      closeMessagePanel: 'Close message panel',
      loadingHistory: 'Loading history...',
      noPreviousMessages: 'No previous messages. Start the conversation below.',
      messagePlaceholder: 'Type your message...',
      send: 'Send',
      messageSentRefresh: 'Message sent — refresh to see it',
      attachmentMessage: 'Attachment',
      failedToLoad: 'Failed to load student details',
      failedToSendMessage: 'Failed to send message',
      courseContextMissing: 'Course context is missing. Please navigate to this student from the dashboard.',
      parentName: 'My students',
      pageTitle: 'Student',
      colLesson: 'Lesson',
      colProgress: 'Progress',
      colStatus: 'Status',
      colDate: 'Date',
    },
    quizFeedback: {
      loading: 'Loading quiz attempt...',
      backToDashboard: 'Back to dashboard',
      backToStudent: 'Back to the student',
      title: 'Quiz feedback',
      subtitle: 'Provide feedback and guidance to {name}',
      submittedSuccess: 'Feedback submitted successfully! Redirecting...',
      quizDetails: 'Quiz details',
      quizTitleLabel: 'Quiz title',
      quizTitleFallback: 'Quiz attempt',
      studentScoreLabel: 'Student score',
      passRequiredLabel: 'Pass required',
      submittedLabel: 'Submitted',
      studentAnswers: 'Student answers',
      questionNumber: 'Question {number}',
      correct: 'Correct',
      incorrect: 'Incorrect',
      studentAnswer: 'Student answer:',
      correctAnswer: 'Correct answer:',
      noAnswer: 'No answer',
      yourFeedback: 'Your feedback',
      editingNotice: 'You already gave feedback on this attempt. Saving replaces it.',
      feedbackLabel: 'Feedback *',
      feedbackPlaceholder: 'Provide constructive feedback about their performance. Supports markdown formatting.',
      feedbackHint: 'Supports **bold**, *italic*, and line breaks',
      suggestionsLabel: 'Suggestions for improvement (optional)',
      suggestionsPlaceholder: 'Provide specific suggestions for improvement and next steps.',
      submitFeedback: 'Submit feedback',
      updateFeedback: 'Update feedback',
      cancel: 'Cancel',
      feedbackRequired: 'Feedback is required',
      missingContext: "The course or the student is missing. Open this page from the student's page.",
      notFound: 'Quiz attempt not found',
      failedToLoad: 'Failed to load quiz attempt',
      failedToSubmit: 'Failed to submit feedback',
    },
    atRisk: {
      title: 'At-risk students',
      loading: 'Loading at-risk notifications...',
      accessDenied: 'Access denied',
      accessDeniedMsg: 'Only teachers can access this feature.',
      returnToDashboard: 'Return to dashboard',
      subtitleNeedAttentionOne: '{count} student needs attention',
      subtitleNeedAttentionOther: '{count} students need attention',
      subtitleAllOnTrack: 'Monitor and support students who are falling behind',
      allOnTrack: 'All students are on track',
      noActiveNotifications: 'Nobody is at risk right now. Students who have not studied for 7+ days or are struggling on quizzes will show up here.',
      inactive: 'Inactive',
      lowQuizScore: 'Low quiz score',
      unansweredQuestion: 'Unanswered question',
      sendMessage: 'Send message',
      studentIdUnavailable: 'Student ID unavailable in notification',
      courseUnavailable: 'Course unavailable in notification',
      viewDetails: 'View details',
      dismissing: 'Dismissing...',
      dismiss: 'Dismiss',
      sendMessageTo: 'Send message to {name}',
      messagePlaceholder: 'Write a supportive message or intervention guidance...',
      cancel: 'Cancel',
      unknownStudent: 'Unknown student',
      prefillInactive: 'you have been inactive recently',
      prefillLowQuizScore: 'you may be struggling with some quizzes',
      prefillUnansweredQuestion: 'you have an unanswered question',
      prefillMessage: 'Hi {name}, I noticed {reason}. I wanted to check in and offer support.',
      messageEmpty: 'Message cannot be empty',
      missingStudentId: 'Cannot identify student — missing student ID in notification metadata',
      missingCourseId: 'Cannot identify the course — missing course ID in the notification',
      failedToLoad: 'Failed to load at-risk notifications',
      failedToMarkRead: 'Failed to mark as read',
      failedToSendMessage: 'Failed to send message',
      filterAll: 'All',
      filterAria: 'Filter by reason',
    },
    metrics: {
      notAssigned: "You're not assigned to this course, so its metrics are hidden. Ask an admin to assign you.",
      noCoursesTitle: 'Not assigned to a course yet',
      noCoursesDesc: "Once you're assigned to a course, its effectiveness metrics will appear here.",
      title: 'Metrics',
      subtitle: 'Track your course performance and student outcomes',
      loading: 'Loading metrics...',
      selectCourse: 'Select course',
      selectCoursePlaceholder: 'Select a course...',
      completionRate: 'Completion rate',
      completionRateDesc: 'Average across all assigned students',
      avgQuizScore: 'Average quiz score',
      avgQuizScoreDesc: 'Latest attempt per quiz, all students',
      activeLast7Days: 'Active (last 7 days)',
      activeLast7DaysDesc: '{percent}% of assigned students',
      totalAssigned: 'Total assigned',
      totalAssignedDesc: 'Students assigned to you',
      atRiskStudents: 'At-risk students',
      atRiskStudentsDesc: '{percent}% of your students',
      feedbackGiven: 'Feedback given',
      feedbackGivenDesc: 'Quiz attempts with teacher feedback',
      summary: 'Summary',
      needAttentionTitle: 'Students need attention',
      needAttentionDescOne: '{count} student is at risk: inactive for 7+ days or an average quiz score below 60%.',
      needAttentionDescOther: '{count} students are at risk: inactive for 7+ days or an average quiz score below 60%.',
      strongCompletionTitle: 'Strong completion rate',
      strongCompletionDesc: 'Your students are completing the course at a high rate ({percent}%). Keep it up!',
      noFeedbackTitle: 'No feedback given yet',
      noFeedbackDesc: "You haven't provided quiz feedback yet. Feedback helps students improve and boosts engagement.",
      noAtRiskTitle: 'No at-risk students',
      noAtRiskDesc: 'All your students are on track. Great teaching!',
      noInsightsYet: 'No insights yet',
      noInsightsDesc: 'Once students are assigned to this course, insights will appear here.',
      selectCoursePrompt: 'Select a course to view effectiveness metrics',
      failedToLoad: 'Failed to load metrics',
      failedToLoadCourses: 'Failed to load courses',
      viewAtRisk: 'View at-risk students',
    },
    qa: {
      noCourseAccessTitle: 'Not assigned to a course yet',
      noCourseAccess: "You don't have access to this course's lessons yet. Ask an admin to assign you to the course.",
      title: 'Q&A',
      legendAmber: 'Unanswered for over 48 hours',
      legendRed: 'Unanswered for over 72 hours',
      courseLabel: 'Course',
      selectCoursePlaceholder: 'Select a course...',
      filterUnanswered: 'Unanswered',
      filterAll: 'All',
      filterAnswered: 'Answered',
      loading: 'Loading Q&A threads...',
      noUnanswered: 'No unanswered questions — great job!',
      noUnansweredDesc: 'New questions from your students will appear here.',
      noThreads: 'No threads yet.',
      noThreadsDesc: 'Questions your students ask under a lesson will appear here.',
      replies: 'Replies',
      repliesOne: 'reply',
      repliesOther: 'replies',
      loadingReplies: 'Loading replies...',
      noRepliesYet: 'No replies yet — be the first to respond!',
      teacherBadge: 'Teacher',
      studentFallback: 'Student',
      userFallback: 'User',
      postReply: 'Post a reply',
      replyPlaceholder: 'Type your response here...',
      charCount: '{count}/2000',
      cancel: 'Cancel',
      postReplyBtn: 'Post reply',
      updatesEvery15s: 'Updates every 15 seconds',
      liveBadge: 'Live',
      backToQA: 'Back to Q&A',
      answered: 'Answered',
      open: 'Open',
      failedToLoadCourses: 'Failed to load courses',
      failedToLoadThreads: 'Failed to load Q&A threads',
      failedToPostReply: 'Failed to post reply',
      replyPostedRefresh: 'Reply posted — refresh to see update',
      lessHourAgo: 'Less than 1h ago',
      hoursAgo: '{count}h ago',
      daysAgo: '{count}d ago',
      urgencyBadge72: 'Very late',
      urgencyBadge48: 'Late',
      subtitle: "Answer your students' questions",
      legendAria: 'Urgency legend',
      filterAria: 'Filter threads',
    },
  },
  ru: {
    dashboard: {
      notAssignedTitle: 'Вы пока не назначены на курс',
      notAssigned: "Вы пока не назначены на этот курс, поэтому его студенты скрыты. Попросите администратора назначить вас.",
      title: 'Мои студенты',
      subtitle: 'Управляйте назначенными курсами и прогрессом студентов',
      loadingCourses: 'Загрузка курсов...',
      selectCourse: 'Выберите курс',
      selectCoursePlaceholder: 'Выберите курс...',
      coursesLabelOne: '{count} студент',
      coursesLabelFew: '{count} студента',
      coursesLabelMany: '{count} студентов',
      searchPlaceholder: 'Поиск студентов...',
      searchAria: 'Поиск студентов по имени или email',
      sortLabel: 'Сортировка',
      filterAllStatuses: 'Все статусы',
      filterActive: 'Активные',
      filterCompleted: 'Завершено',
      filterInactive: 'Неактивные',
      filterAtRisk: 'В зоне риска',
      statusActive: 'Актив',
      statusCompleted: 'Завершён',
      statusInactive: 'Неактивен',
      statusAtRisk: 'В зоне риска',
      allStatuses: 'Все статусы',
      sortAtRisk: 'Сначала в зоне риска',
      sortProgressAsc: 'Прогресс (по возрастанию)',
      sortLastActive: 'Последняя активность',
      sortAlphabetical: 'По алфавиту',
      loadingStudents: 'Загрузка студентов...',
      emptyStudents: 'Пока нет студентов, назначенных вам на этот курс',
      emptyStudentsDesc: 'Назначенные вам студенты появятся здесь вместе с их прогрессом.',
      colName: 'Студент',
      colStatus: 'Статус',
      colProgress: 'Прогресс',
      colLastActive: 'Последняя активность',
      colQuizAverage: 'Средний балл теста',
      colAction: 'Действие',
      atRiskBadge: 'В зоне риска',
      view: 'Просмотр',
      failedToLoadStudents: 'Не удалось загрузить студентов',
      failedToLoadCourses: 'Не удалось загрузить курсы',
      never: 'Никогда',
      yesterday: 'Вчера',
      daysAgoOne: '{count} день назад',
      daysAgoFew: '{count} дня назад',
      daysAgoMany: '{count} дней назад',
      weeksAgoOne: '{count} неделю назад',
      weeksAgoFew: '{count} недели назад',
      weeksAgoMany: '{count} недель назад',
      monthsAgoOne: '{count} месяц назад',
      monthsAgoFew: '{count} месяца назад',
      monthsAgoMany: '{count} месяцев назад',
      clearFilters: 'Сбросить фильтры',
      noResultsTitle: 'Студенты не найдены',
      noResultsDesc: 'Попробуйте другое имя, email или статус.',
      filterStatusAria: 'Фильтр по статусу',
      sortAria: 'Сортировка студентов',
      tableAria: 'Студенты',
    },
    studentDetail: {
      loading: 'Загрузка данных студента...',
      backToDashboard: 'Назад к панели',
      notFound: 'Студент не найден',
      notFoundDesc: 'Этого студента нет в этом курсе, либо ссылка устарела.',
      enrolled: 'Записан',
      completedOn: 'Завершено: {date}',
      overallProgress: 'Общий прогресс',
      quizAverage: 'Средний балл теста',
      basedOnAttempts: 'На основе {count} попыток',
      lessonsCompleted: 'Завершено уроков',
      lessonCompletionProgress: 'Прогресс прохождения уроков',
      completionPercent: 'Завершение %',
      quizPerformance: 'Результаты тестов',
      quizFallback: 'Тест',
      scorePercent: 'Балл %',
      lessonsProgress: 'Прогресс по урокам',
      noLessonsData: 'Нет данных по урокам',
      lessonFallbackTitle: 'Урок {number}',
      completed: 'Завершено',
      notStarted: 'Не начато',
      quizAttempts: 'Попытки теста',
      correctOf: '{correct}/{total} верно',
      inProgress: 'В процессе',
      passed: 'Пройден',
      failed: 'Не пройден',
      editFeedback: 'Редактировать отзыв',
      provideFeedback: 'Оставить отзыв',
      refreshData: 'Обновить данные',
      messageStudent: 'Написать студенту',
      messagePanelTitle: 'Сообщение для {name}',
      closeMessagePanel: 'Закрыть панель сообщений',
      loadingHistory: 'Загрузка истории...',
      noPreviousMessages: 'Предыдущих сообщений нет. Начните разговор ниже.',
      messagePlaceholder: 'Введите сообщение...',
      send: 'Отправить',
      messageSentRefresh: 'Сообщение отправлено — обновите, чтобы увидеть',
      attachmentMessage: 'Вложение',
      failedToLoad: 'Не удалось загрузить данные студента',
      failedToSendMessage: 'Не удалось отправить сообщение',
      courseContextMissing: 'Отсутствует контекст курса. Перейдите к этому студенту с панели управления.',
      parentName: 'Мои студенты',
      pageTitle: 'Студент',
      colLesson: 'Урок',
      colProgress: 'Прогресс',
      colStatus: 'Статус',
      colDate: 'Дата',
    },
    quizFeedback: {
      loading: 'Загрузка попытки теста...',
      backToDashboard: 'Назад к панели',
      backToStudent: 'Назад к студенту',
      title: 'Отзыв по тесту',
      subtitle: 'Оставьте отзыв и рекомендации для {name}',
      submittedSuccess: 'Отзыв успешно отправлен! Перенаправление...',
      quizDetails: 'Детали теста',
      quizTitleLabel: 'Название теста',
      quizTitleFallback: 'Попытка теста',
      studentScoreLabel: 'Балл студента',
      passRequiredLabel: 'Проходной балл',
      submittedLabel: 'Отправлено',
      studentAnswers: 'Ответы студента',
      questionNumber: 'Вопрос {number}',
      correct: 'Верно',
      incorrect: 'Неверно',
      studentAnswer: 'Ответ студента:',
      correctAnswer: 'Правильный ответ:',
      noAnswer: 'Нет ответа',
      yourFeedback: 'Ваш отзыв',
      editingNotice: 'Вы уже оставили отзыв по этой попытке. Сохранение заменит его.',
      feedbackLabel: 'Отзыв *',
      feedbackPlaceholder: 'Дайте конструктивный отзыв об их успеваемости. Поддерживается разметка markdown.',
      feedbackHint: 'Поддерживаются **жирный**, *курсив* и переносы строк',
      suggestionsLabel: 'Рекомендации по улучшению (необязательно)',
      suggestionsPlaceholder: 'Укажите конкретные рекомендации по улучшению и дальнейшим шагам.',
      submitFeedback: 'Отправить отзыв',
      updateFeedback: 'Обновить отзыв',
      cancel: 'Отмена',
      feedbackRequired: 'Отзыв обязателен',
      missingContext: 'Не удалось определить курс или студента. Откройте эту страницу из карточки студента.',
      notFound: 'Попытка теста не найдена',
      failedToLoad: 'Не удалось загрузить попытку теста',
      failedToSubmit: 'Не удалось отправить отзыв',
    },
    atRisk: {
      title: 'Студенты в зоне риска',
      loading: 'Загрузка уведомлений о риске...',
      accessDenied: 'Доступ запрещён',
      accessDeniedMsg: 'Эта функция доступна только преподавателям.',
      returnToDashboard: 'Вернуться на панель',
      subtitleNeedAttentionOne: '{count} студент требует внимания',
      subtitleNeedAttentionFew: '{count} студента требуют внимания',
      subtitleNeedAttentionMany: '{count} студентов требуют внимания',
      subtitleAllOnTrack: 'Отслеживайте и поддерживайте студентов, отстающих в обучении',
      allOnTrack: 'Все студенты успевают',
      noActiveNotifications: 'Сейчас никто не в зоне риска. Здесь появятся студенты, которые не занимаются 7+ дней или плохо справляются с тестами.',
      inactive: 'Неактивен',
      lowQuizScore: 'Низкий балл теста',
      unansweredQuestion: 'Вопрос без ответа',
      sendMessage: 'Отправить сообщение',
      studentIdUnavailable: 'ID студента недоступен в уведомлении',
      courseUnavailable: 'Курс недоступен в уведомлении',
      viewDetails: 'Подробнее',
      dismissing: 'Отклонение...',
      dismiss: 'Отклонить',
      sendMessageTo: 'Отправить сообщение {name}',
      messagePlaceholder: 'Напишите поддерживающее сообщение или рекомендацию...',
      cancel: 'Отмена',
      unknownStudent: 'Неизвестный студент',
      prefillInactive: 'вы были неактивны в последнее время',
      prefillLowQuizScore: 'у вас могут быть трудности с некоторыми тестами',
      prefillUnansweredQuestion: 'у вас есть вопрос без ответа',
      prefillMessage: 'Здравствуйте, {name}, я заметил(а), что {reason}. Хотел(а) узнать, как у вас дела, и предложить помощь.',
      messageEmpty: 'Сообщение не может быть пустым',
      missingStudentId: 'Невозможно определить студента — отсутствует ID студента в данных уведомления',
      missingCourseId: 'Невозможно определить курс — отсутствует ID курса в данных уведомления',
      failedToLoad: 'Не удалось загрузить уведомления о риске',
      failedToMarkRead: 'Не удалось отметить как прочитанное',
      failedToSendMessage: 'Не удалось отправить сообщение',
      filterAll: 'Все',
      filterAria: 'Фильтр по причине',
    },
    metrics: {
      notAssigned: "Вы не назначены на этот курс, поэтому его показатели скрыты. Попросите администратора назначить вас.",
      noCoursesTitle: 'Вы пока не назначены на курс',
      noCoursesDesc: "Как только вас назначат на курс, здесь появятся его показатели эффективности.",
      title: 'Метрики',
      subtitle: 'Отслеживайте эффективность курса и результаты студентов',
      loading: 'Загрузка показателей...',
      selectCourse: 'Выберите курс',
      selectCoursePlaceholder: 'Выберите курс...',
      completionRate: 'Процент завершения',
      completionRateDesc: 'Среднее значение по всем назначенным студентам',
      avgQuizScore: 'Средний балл теста',
      avgQuizScoreDesc: 'Последняя попытка по каждому тесту, все студенты',
      activeLast7Days: 'Активны (последние 7 дней)',
      activeLast7DaysDesc: '{percent}% от назначенных студентов',
      totalAssigned: 'Всего назначено',
      totalAssignedDesc: 'Студентов, назначенных вам',
      atRiskStudents: 'Студенты в зоне риска',
      atRiskStudentsDesc: '{percent}% ваших студентов',
      feedbackGiven: 'Отзывов дано',
      feedbackGivenDesc: 'Попытки теста с отзывом преподавателя',
      summary: 'Сводка',
      needAttentionTitle: 'Студентам нужно внимание',
      needAttentionDescOne: '{count} студент в зоне риска: не занимается 7+ дней или средний балл теста ниже 60%.',
      needAttentionDescFew: '{count} студента в зоне риска: не занимаются 7+ дней или средний балл теста ниже 60%.',
      needAttentionDescMany: '{count} студентов в зоне риска: не занимаются 7+ дней или средний балл теста ниже 60%.',
      strongCompletionTitle: 'Высокий процент завершения',
      strongCompletionDesc: 'Ваши студенты завершают курс с высоким показателем ({percent}%). Так держать!',
      noFeedbackTitle: 'Отзывы ещё не даны',
      noFeedbackDesc: 'Вы ещё не оставили отзыв по тестам. Отзыв помогает студентам улучшаться и повышает вовлечённость.',
      noAtRiskTitle: 'Нет студентов в зоне риска',
      noAtRiskDesc: 'Все ваши студенты успевают. Отличное преподавание!',
      noInsightsYet: 'Пока нет рекомендаций',
      noInsightsDesc: 'Когда на этот курс назначат студентов, рекомендации появятся здесь.',
      selectCoursePrompt: 'Выберите курс, чтобы увидеть показатели эффективности',
      failedToLoad: 'Не удалось загрузить показатели',
      failedToLoadCourses: 'Не удалось загрузить курсы',
      viewAtRisk: 'Открыть группу риска',
    },
    qa: {
      noCourseAccessTitle: 'Вы пока не назначены на курс',
      noCourseAccess: "У вас пока нет доступа к урокам этого курса. Попросите администратора назначить вас на курс.",
      title: 'Вопросы и ответы',
      legendAmber: 'Без ответа более 48 часов',
      legendRed: 'Без ответа более 72 часов',
      courseLabel: 'Курс',
      selectCoursePlaceholder: 'Выберите курс...',
      filterUnanswered: 'Без ответа',
      filterAll: 'Все',
      filterAnswered: 'С ответом',
      loading: 'Загрузка обсуждений...',
      noUnanswered: 'Нет вопросов без ответа — отличная работа!',
      noUnansweredDesc: 'Новые вопросы студентов появятся здесь.',
      noThreads: 'Пока нет обсуждений.',
      noThreadsDesc: 'Вопросы студентов к урокам появятся здесь.',
      replies: 'Ответы',
      repliesOne: 'ответ',
      repliesFew: 'ответа',
      repliesMany: 'ответов',
      loadingReplies: 'Загрузка ответов...',
      noRepliesYet: 'Пока нет ответов — станьте первым!',
      teacherBadge: 'Преподаватель',
      studentFallback: 'Студент',
      userFallback: 'Пользователь',
      postReply: 'Опубликовать ответ',
      replyPlaceholder: 'Введите ваш ответ здесь...',
      charCount: '{count}/2000',
      cancel: 'Отмена',
      postReplyBtn: 'Опубликовать ответ',
      updatesEvery15s: 'Обновление каждые 15 секунд',
      liveBadge: 'Автообновление',
      backToQA: 'Назад к вопросам и ответам',
      answered: 'Отвечено',
      open: 'Открыто',
      failedToLoadCourses: 'Не удалось загрузить курсы',
      failedToLoadThreads: 'Не удалось загрузить обсуждения',
      failedToPostReply: 'Не удалось опубликовать ответ',
      replyPostedRefresh: 'Ответ опубликован — обновите, чтобы увидеть',
      lessHourAgo: 'Менее часа назад',
      hoursAgo: '{count} ч. назад',
      daysAgo: '{count} дн. назад',
      urgencyBadge72: 'Сильно просрочено',
      urgencyBadge48: 'Просрочено',
      subtitle: 'Отвечайте на вопросы студентов',
      legendAria: 'Обозначения срочности',
      filterAria: 'Фильтр обсуждений',
    },
  },
  uz: {
    dashboard: {
      notAssignedTitle: 'Sizga hali kurs biriktirilmagan',
      notAssigned: "Siz hali bu kursga biriktirilmagansiz, shuning uchun o'quvchilari yashirin. Administratordan biriktirishni so'rang.",
      title: "Mening o'quvchilarim",
      subtitle: "Sizga biriktirilgan kurslar va o'quvchilar progressini boshqaring",
      loadingCourses: 'Kurslar yuklanmoqda...',
      selectCourse: 'Kursni tanlang',
      selectCoursePlaceholder: 'Kursni tanlang...',
      coursesLabelOther: "{count} ta o'quvchi",
      searchPlaceholder: "O'quvchini qidirish...",
      searchAria: "O'quvchilarni ism yoki email bo'yicha qidirish",
      sortLabel: 'Saralash',
      filterAllStatuses: 'Barcha holatlar',
      filterActive: 'Faol',
      filterCompleted: 'Yakunlangan',
      filterInactive: 'Nofaol',
      filterAtRisk: 'Xavf ostida',
      statusActive: 'Faol',
      statusCompleted: 'Yakunlangan',
      statusInactive: 'Nofaol',
      statusAtRisk: 'Xavf ostida',
      allStatuses: 'Barcha holatlar',
      sortAtRisk: 'Avval xavf ostidagilar',
      sortProgressAsc: "Progress (o'sish bo'yicha)",
      sortLastActive: 'Oxirgi faollik',
      sortAlphabetical: "Alifbo bo'yicha",
      loadingStudents: "O'quvchilar yuklanmoqda...",
      emptyStudents: "Bu kursda sizga hali o'quvchi biriktirilmagan",
      emptyStudentsDesc: "Sizga biriktirilgan o'quvchilar progressi bilan shu yerda ko'rinadi.",
      colName: "O'quvchi",
      colStatus: 'Holat',
      colProgress: 'Progress',
      colLastActive: 'Oxirgi faollik',
      colQuizAverage: "Test o'rtacha bahosi",
      colAction: 'Amal',
      atRiskBadge: 'Xavf ostida',
      view: "Ko'rish",
      failedToLoadStudents: "O'quvchilarni yuklab bo'lmadi",
      failedToLoadCourses: "Kurslarni yuklab bo'lmadi",
      never: 'Hech qachon',
      yesterday: 'Kecha',
      daysAgoOther: '{count} kun oldin',
      weeksAgoOther: '{count} hafta oldin',
      monthsAgoOther: '{count} oy oldin',
      clearFilters: 'Filtrlarni tozalash',
      noResultsTitle: "O'quvchi topilmadi",
      noResultsDesc: "Boshqa ism, email yoki holatni sinab ko'ring.",
      filterStatusAria: "Holat bo'yicha filtr",
      sortAria: "O'quvchilarni saralash",
      tableAria: "O'quvchilar",
    },
    studentDetail: {
      loading: "O'quvchi ma'lumotlari yuklanmoqda...",
      backToDashboard: 'Panelga qaytish',
      notFound: "O'quvchi topilmadi",
      notFoundDesc: "Bu o'quvchi ushbu kursda yo'q yoki havola eskirgan.",
      enrolled: "Ro'yxatdan o'tgan",
      completedOn: 'Yakunlangan: {date}',
      overallProgress: 'Umumiy progress',
      quizAverage: "Test o'rtacha bahosi",
      basedOnAttempts: '{count} ta urinish asosida',
      lessonsCompleted: 'Yakunlangan darslar',
      lessonCompletionProgress: 'Dars yakunlash jarayoni',
      completionPercent: 'Yakunlanish %',
      quizPerformance: 'Test natijalari',
      quizFallback: 'Test',
      scorePercent: 'Ball %',
      lessonsProgress: "Darslar bo'yicha progress",
      noLessonsData: "Darslar bo'yicha ma'lumot yo'q",
      lessonFallbackTitle: '{number}-dars',
      completed: 'Yakunlangan',
      notStarted: 'Boshlanmagan',
      quizAttempts: 'Test urinishlari',
      correctOf: "{correct}/{total} to'g'ri",
      inProgress: 'Jarayonda',
      passed: "O'tdi",
      failed: "O'tmadi",
      editFeedback: 'Fikrni tahrirlash',
      provideFeedback: 'Fikr bildirish',
      refreshData: "Ma'lumotni yangilash",
      messageStudent: "O'quvchiga xabar yozish",
      messagePanelTitle: '{name}ga xabar',
      closeMessagePanel: 'Xabar panelini yopish',
      loadingHistory: 'Tarix yuklanmoqda...',
      noPreviousMessages: "Avvalgi xabarlar yo'q. Suhbatni quyida boshlang.",
      messagePlaceholder: 'Xabaringizni yozing...',
      send: 'Yuborish',
      messageSentRefresh: "Xabar yuborildi — ko'rish uchun yangilang",
      attachmentMessage: 'Biriktirma',
      failedToLoad: "O'quvchi ma'lumotlarini yuklab bo'lmadi",
      failedToSendMessage: "Xabarni yuborib bo'lmadi",
      courseContextMissing: "Kurs konteksti topilmadi. Bu o'quvchiga panel orqali o'ting.",
      parentName: "Mening o'quvchilarim",
      pageTitle: "O'quvchi",
      colLesson: 'Dars',
      colProgress: 'Progress',
      colStatus: 'Holat',
      colDate: 'Sana',
    },
    quizFeedback: {
      loading: 'Test urinishi yuklanmoqda...',
      backToDashboard: 'Panelga qaytish',
      backToStudent: "O'quvchiga qaytish",
      title: "Test bo'yicha fikr",
      subtitle: '{name} uchun fikr va tavsiyalar bering',
      submittedSuccess: "Fikr muvaffaqiyatli yuborildi! Yo'naltirilmoqda...",
      quizDetails: 'Test tafsilotlari',
      quizTitleLabel: 'Test nomi',
      quizTitleFallback: 'Test urinishi',
      studentScoreLabel: "O'quvchi bahosi",
      passRequiredLabel: "O'tish bali",
      submittedLabel: 'Yuborilgan',
      studentAnswers: "O'quvchi javoblari",
      questionNumber: '{number}-savol',
      correct: "To'g'ri",
      incorrect: "Noto'g'ri",
      studentAnswer: "O'quvchi javobi:",
      correctAnswer: "To'g'ri javob:",
      noAnswer: "Javob yo'q",
      yourFeedback: 'Sizning fikringiz',
      editingNotice: 'Siz bu urinish uchun allaqachon fikr bildirgansiz. Saqlash uni almashtiradi.',
      feedbackLabel: 'Fikr *',
      feedbackPlaceholder: "O'quvchining natijasi haqida konstruktiv fikr bildiring. Markdown formatlash qo'llab-quvvatlanadi.",
      feedbackHint: "**qalin**, *kursiv* va qator ko'chirish qo'llab-quvvatlanadi",
      suggestionsLabel: "Yaxshilash bo'yicha tavsiyalar (ixtiyoriy)",
      suggestionsPlaceholder: "Yaxshilash va keyingi qadamlar bo'yicha aniq tavsiyalar bering.",
      submitFeedback: 'Fikrni yuborish',
      updateFeedback: 'Fikrni yangilash',
      cancel: 'Bekor qilish',
      feedbackRequired: 'Fikr kiritish shart',
      missingContext: "Kurs yoki o'quvchi aniqlanmadi. Bu sahifani o'quvchi sahifasidan oching.",
      notFound: 'Test urinishi topilmadi',
      failedToLoad: "Test urinishini yuklab bo'lmadi",
      failedToSubmit: "Fikrni yuborib bo'lmadi",
    },
    atRisk: {
      title: "Xavf ostidagi o'quvchilar",
      loading: 'Xavf haqidagi bildirishnomalar yuklanmoqda...',
      accessDenied: 'Kirish rad etildi',
      accessDeniedMsg: "Bu funksiyadan faqat o'qituvchilar foydalana oladi.",
      returnToDashboard: 'Panelga qaytish',
      subtitleNeedAttentionOther: "{count} ta o'quvchi e'tiborni talab qiladi",
      subtitleAllOnTrack: "Orqada qolayotgan o'quvchilarni kuzating va qo'llab-quvvatlang",
      allOnTrack: "Barcha o'quvchilar rejaga muvofiq",
      noActiveNotifications: "Hozircha xavf ostida o'quvchi yo'q. 7 kundan ortiq o'qimagan yoki testlarda qiynalayotgan o'quvchilar shu yerda ko'rinadi.",
      inactive: 'Nofaol',
      lowQuizScore: 'Test bahosi past',
      unansweredQuestion: 'Javobsiz savol',
      sendMessage: 'Xabar yuborish',
      studentIdUnavailable: "Bildirishnomada o'quvchi ID mavjud emas",
      courseUnavailable: 'Bildirishnomada kurs mavjud emas',
      viewDetails: "Batafsil ko'rish",
      dismissing: 'Yopilmoqda...',
      dismiss: 'Yopish',
      sendMessageTo: '{name}ga xabar yuborish',
      messagePlaceholder: "Qo'llab-quvvatlovchi xabar yoki tavsiya yozing...",
      cancel: 'Bekor qilish',
      unknownStudent: "Noma'lum o'quvchi",
      prefillInactive: "siz so'nggi paytda nofaol bo'lgansiz",
      prefillLowQuizScore: "ba'zi testlarda qiynalayotgan bo'lishingiz mumkin",
      prefillUnansweredQuestion: 'sizda javobsiz savol bor',
      prefillMessage: 'Salom, {name}, {reason} ekanini payqadim. Ahvolingizni bilib, yordam berishni xohladim.',
      messageEmpty: "Xabar bo'sh bo'lishi mumkin emas",
      missingStudentId: "O'quvchini aniqlab bo'lmadi — bildirishnoma ma'lumotlarida o'quvchi ID yo'q",
      missingCourseId: "Kursni aniqlab bo'lmadi — bildirishnoma ma'lumotlarida kurs ID yo'q",
      failedToLoad: "Xavf bildirishnomalarini yuklab bo'lmadi",
      failedToMarkRead: "O'qilgan deb belgilab bo'lmadi",
      failedToSendMessage: "Xabarni yuborib bo'lmadi",
      filterAll: 'Hammasi',
      filterAria: "Sabab bo'yicha filtr",
    },
    metrics: {
      notAssigned: "Siz bu kursga biriktirilmagansiz, shuning uchun ko'rsatkichlari yashirin. Administratordan biriktirishni so'rang.",
      noCoursesTitle: 'Sizga hali kurs biriktirilmagan',
      noCoursesDesc: "Kurs biriktirilgach, uning samaradorlik ko'rsatkichlari shu yerda ko'rinadi.",
      title: "Ko'rsatkichlar",
      subtitle: "Kurs samaradorligi va o'quvchilar natijalarini kuzating",
      loading: "Ko'rsatkichlar yuklanmoqda...",
      selectCourse: 'Kursni tanlang',
      selectCoursePlaceholder: 'Kursni tanlang...',
      completionRate: 'Yakunlash darajasi',
      completionRateDesc: "Barcha biriktirilgan o'quvchilar bo'yicha o'rtacha",
      avgQuizScore: "Test o'rtacha bahosi",
      avgQuizScoreDesc: "Har bir test bo'yicha oxirgi urinish, barcha o'quvchilar",
      activeLast7Days: 'Faol (oxirgi 7 kun)',
      activeLast7DaysDesc: "Biriktirilgan o'quvchilarning {percent} foizi",
      totalAssigned: 'Jami biriktirilgan',
      totalAssignedDesc: "Sizga biriktirilgan o'quvchilar",
      atRiskStudents: "Xavf ostidagi o'quvchilar",
      atRiskStudentsDesc: "Guruhingizdagi o'quvchilarning {percent} foizi",
      feedbackGiven: 'Berilgan fikrlar',
      feedbackGivenDesc: "O'qituvchi fikri bilan test urinishlari",
      summary: 'Xulosa',
      needAttentionTitle: "O'quvchilar e'tiborni talab qiladi",
      needAttentionDescOther: "{count} ta o'quvchi xavf ostida: 7 kundan ortiq faol bo'lmagan yoki test o'rtacha bahosi 60% dan past.",
      strongCompletionTitle: 'Yuqori yakunlash darajasi',
      strongCompletionDesc: "O'quvchilaringiz kursni yuqori darajada yakunlamoqda ({percent}%). Shunday davom eting!",
      noFeedbackTitle: 'Hali fikr berilmagan',
      noFeedbackDesc: "Siz hali test bo'yicha fikr bermagansiz. Fikr o'quvchilarga yaxshilanishga va faollikni oshirishga yordam beradi.",
      noAtRiskTitle: "Xavf ostidagi o'quvchilar yo'q",
      noAtRiskDesc: "Barcha o'quvchilaringiz rejaga muvofiq. Ajoyib o'qitish!",
      noInsightsYet: "Hali tavsiyalar yo'q",
      noInsightsDesc: "Bu kursga o'quvchilar biriktirilgach, tavsiyalar shu yerda ko'rinadi.",
      selectCoursePrompt: "Samaradorlik ko'rsatkichlarini ko'rish uchun kursni tanlang",
      failedToLoad: "Ko'rsatkichlarni yuklab bo'lmadi",
      failedToLoadCourses: "Kurslarni yuklab bo'lmadi",
      viewAtRisk: "Xavf ostidagilarni ko'rish",
    },
    qa: {
      noCourseAccessTitle: 'Sizga hali kurs biriktirilmagan',
      noCourseAccess: "Sizda hali bu kurs darslariga kirish huquqi yo'q. Administratordan sizni kursga biriktirishni so'rang.",
      title: 'Savol-javob',
      legendAmber: '48 soatdan ortiq javobsiz',
      legendRed: '72 soatdan ortiq javobsiz',
      courseLabel: 'Kurs',
      selectCoursePlaceholder: 'Kursni tanlang...',
      filterUnanswered: 'Javobsiz',
      filterAll: 'Hammasi',
      filterAnswered: 'Javobli',
      loading: 'Savol-javob mavzulari yuklanmoqda...',
      noUnanswered: "Javobsiz savollar yo'q — ajoyib ish!",
      noUnansweredDesc: "O'quvchilardan yangi savollar kelsa, shu yerda ko'rinadi.",
      noThreads: "Hali mavzular yo'q.",
      noThreadsDesc: "O'quvchilar dars ostida savol bersa, shu yerda ko'rinadi.",
      replies: 'Javoblar',
      repliesOther: 'ta javob',
      loadingReplies: 'Javoblar yuklanmoqda...',
      noRepliesYet: "Hali javoblar yo'q — birinchi bo'lib javob bering!",
      teacherBadge: "O'qituvchi",
      studentFallback: "O'quvchi",
      userFallback: 'Foydalanuvchi',
      postReply: 'Javob joylash',
      replyPlaceholder: 'Javobingizni shu yerga yozing...',
      charCount: '{count}/2000',
      cancel: 'Bekor qilish',
      postReplyBtn: 'Javobni joylash',
      updatesEvery15s: 'Har 15 soniyada yangilanadi',
      liveBadge: 'Jonli',
      backToQA: 'Savol-javobga qaytish',
      answered: 'Javob berilgan',
      open: 'Ochiq',
      failedToLoadCourses: "Kurslarni yuklab bo'lmadi",
      failedToLoadThreads: "Savol-javob mavzularini yuklab bo'lmadi",
      failedToPostReply: "Javobni joylab bo'lmadi",
      replyPostedRefresh: "Javob joylandi — ko'rish uchun yangilang",
      lessHourAgo: '1 soatdan kam vaqt oldin',
      hoursAgo: '{count} soat oldin',
      daysAgo: '{count} kun oldin',
      urgencyBadge72: 'Juda kechikkan',
      urgencyBadge48: 'Kechikkan',
      subtitle: "O'quvchilar savollariga javob bering",
      legendAria: 'Shoshilinchlik belgilari',
      filterAria: 'Mavzularni saralash',
    },
  },
};

export default teacher;
